<spark-shared-shell>
  <router-outlet></router-outlet>
</spark-shared-shell>